// extracted by mini-css-extract-plugin
export var container = "_v0-0";
export var table = "_v0-2";
export var tableWrapper = "_v0-1";